export const emailRegex = /^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/
export const phoneRegex = /^[0-9-+\s]+$/

// some zipcodes
// https://support.nmi.com/hc/en-gb/articles/115002375583-Test-Cards#h_01H05ETRXHY9PBE9S6KYT4QYH0
export const zipcodeRegex = /^[a-z0-9][a-z0-9\- ]{0,10}[a-z0-9]$/i
